import { FunctionComponent, ReactNode, useCallback } from "react";
import { ThemedLayoutV2 } from "@refinedev/mui";
import { TitleProps } from "@refinedev/core";
import { Sider } from "../Sider";
import { SyncrosaleThemedTitle } from "../SyncrosaleThemedTitle";
import { getRuntimeEnv } from "../../../providers/getRuntimeEnv";
import { AdminHeader } from "./AdminHeader";

interface AdminLayoutProps {
  children: ReactNode;
}

// Layout of the admin area. Uses the same ThemedLayoutV2 / Sider / title as the
// seller SyncrosaleLayout, but none of its store bootstrapping: admin users
// have no seller account, so useInitializeApp's marketplace loading and the
// redirect to /store/create must not run here.
export const AdminLayout = ({ children }: AdminLayoutProps) => {
  const isDevEnv = getRuntimeEnv() === "dev";
  const title = isDevEnv ? "SyncroDev" : "Syncrosale";
  const logo = isDevEnv ? "/icons/logo-dev.svg" : "/icons/logo.svg";

  const renderTitle: FunctionComponent<TitleProps> = useCallback(
    (props) => <SyncrosaleThemedTitle {...props} text={title} icon={logo} />,
    [title, logo],
  );

  return (
    <ThemedLayoutV2 Header={AdminHeader} Title={renderTitle} Sider={Sider}>
      {children}
    </ThemedLayoutV2>
  );
};
